import {
  checkTipsyStudioAccess,
  getTipsyStudioAccessKey,
} from '@/apis/accessRule'
import { userState } from '@/store/user'
import useSWR from 'swr'
import { useRecoilValue } from 'recoil'

export default function useTipsyStudioAccess() {
  const user = useRecoilValue(userState)
  const swrKey = getTipsyStudioAccessKey(user?.user_id)
  const { data, error, mutate } = useSWR(swrKey, checkTipsyStudioAccess, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })
  const isAuthenticated = Boolean(user?.user_id)

  return {
    studioAccess: data,
    studioAccessError: error,
    isStudioAccessLoading: isAuthenticated && !data && !error,
    isStudioAllowed: data?.allowed === true,
    mutateStudioAccess: mutate,
  }
}
